import React, { Component } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'



export default class FaIcon extends Component {

    render() {
        const {...props} = this.props
        delete props.color
        if (typeof props.icon === "string") {
            props.icon = ["fal", props.icon]
        }
        return (
            <FontAwesomeIcon className={"fa " + this.props.color} {...props}/>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/FaIcon.js